<div id="deleteTask">
  <div mat-dialog-title>
    <div class="floating-icon">
      <img src="../../../../../assets/images/delete-task.png" />
    </div>
    <span>Delete Task</span>
  </div>
  <mat-dialog-content class="mat-typography">
    <div class="modal-desc">Are you sure you want to delete this task?</div>
    <div class="modal-task-name">‘{{ task?.title }}’</div>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button mat-dialog-close class="btn btn-secondary me-auto">Cancel</button>
    <button class="btn btn-danger" [class.disabled]="isLoading" (click)="deleteTask()">Delete</button>
  </mat-dialog-actions>
</div>
